module.exports = __webpack_public_path__ + "img/radio-langkawi.79b41be3.jpg";